/**
 * Crazy Soda Pop — minimal homepage enhancements
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var searchInputs = document.querySelectorAll('[data-csp-collection-search]');
    function collectionGridItems() {
      var grid =
        document.querySelector('#product-grid') ||
        document.querySelector('.product-grid-container .product-grid');
      return grid ? grid.querySelectorAll('.grid__item') : [];
    }
    function applyCollectionSearch(value) {
      var needle = String(value || '').trim().toLowerCase();
      document.querySelectorAll('[data-csp-collection-search]').forEach(function (input) {
        if (input.value !== value) input.value = value;
      });
      collectionGridItems().forEach(function (item) {
        var hay = (item.textContent || '').toLowerCase();
        item.classList.toggle('is-csp-search-hidden', needle !== '' && hay.indexOf(needle) === -1);
      });
    }
    function setPackCardPrice(input) {
      if (!input || !input.getAttribute('data-price')) return;
      var card = input.closest('.card-wrapper, .card, .grid__item');
      if (!card) return;
      var price = input.getAttribute('data-price');
      card.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
        if (el.tagName === 'S' || el.classList.contains('variant-item__old-price')) return;
        el.textContent = price;
      });
    }
    document.querySelectorAll('.csp-pack-size input[name="id"]:checked').forEach(setPackCardPrice);
    document.addEventListener('change', function (event) {
      if (event.target.matches('.csp-pack-size input[name="id"]')) {
        setPackCardPrice(event.target);
      }
    });
    document.addEventListener('click', function (event) {
      var option = event.target.closest('.csp-pack-size__option');
      if (!option) return;
      var input = option.querySelector('input[name="id"]');
      if (input) setPackCardPrice(input);
    });

    if (searchInputs.length) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.matches('[data-csp-collection-search]')) {
          event.preventDefault();
        }
      });
      document.addEventListener('input', function (event) {
        if (event.target.matches('[data-csp-collection-search]')) {
          applyCollectionSearch(event.target.value);
        }
      });
    }

    var header = document.querySelector('.csp-header');
    if (!header) return;

    var clubLink = header.querySelector('a[data-csp-parent-link][href*="soda-discovery"], a[href*="/pages/what-is-the-soda-discovery-club"]');
    if (clubLink) {
      clubLink.classList.add('csp-nav-club-highlight');
    }

    var desktop = window.matchMedia('(min-width: 990px)');
    header.querySelectorAll('[data-csp-parent-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      var details = link.closest('details');
      if (!details) return;

      details.addEventListener('mouseenter', function () {
        if (desktop.matches) details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        if (desktop.matches) details.removeAttribute('open');
      });
    });
  });
})();
